/* eslint-disable */
/**
 * Super admin check — reads from user_profiles.is_super_admin column.
 * Cached in memory after first auth setup fetch.
 * No hardcoded emails.
 */

let _cachedSuperAdmins = new Set();

/** Called by useAuthSetup when profile loads from DB */
export function setSuperAdminCache(userId, isSuperAdmin) {
  if (isSuperAdmin) _cachedSuperAdmins.add(userId);
  else _cachedSuperAdmins.delete(userId);
}

/** Clear cache on logout */
export function clearSuperAdminCache() {
  _cachedSuperAdmins = new Set();
}

/** Synchronous check — uses cached value from DB */
export function isSuperAdmin(user) {
  if (!user?.id) return false;
  return _cachedSuperAdmins.has(user.id);
}
